var map = {
	"./heart-filled.png": "mfYp",
	"./heart.png": "YfaA",
	"./leisure-0.png": "crev",
	"./leisure-1.png": "E3Wh",
	"./leisure-2.png": "NPjz",
	"./leisure-3.png": "R/0R",
	"./leisure-4.png": "3xbO",
	"./powered_by_google_on_white_hdpi.png": "JQW9",
	"./restaurant-0.png": "govv",
	"./restaurant-1.png": "DAa/",
	"./restaurant-2.png": "v6WW",
	"./restaurant-3.png": "sNOq",
	"./restaurant-4.png": "IE4q",
	"./shop-0.png": "aOFL",
	"./shop-1.png": "MnqG",
	"./shop-2.png": "lJ2H",
	"./shop-3.png": "ONRO",
	"./shop-4.png": "R2Us",
	"./sight-0.png": "q1hD",
	"./sight-1.png": "zVvG",
	"./sight-2.png": "ZhSa",
	"./sight-3.png": "k/N5",
	"./sight-4.png": "lupi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1